import { render, staticRenderFns } from "./ArticuloCategoria.vue?vue&type=template&id=1a4ca2f6&"
import script from "./ArticuloCategoria.vue?vue&type=script&lang=js&"
export * from "./ArticuloCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports